import { createSearchParams } from "react-router-dom";

export interface WizardStepPath {
  pathname: string;
  search: string;
}

export const wizardStepPaths = <K extends string>(
  pathname: string,
  stepKeys: readonly K[],
): Record<K, WizardStepPath> =>
  Object.fromEntries(
    stepKeys.map((step) => [step, { pathname, search: createSearchParams({ step }).toString() }]),
  ) as Record<K, WizardStepPath>;
